import React, { useCallback, useContext } from 'react';
import { withTranslation } from 'react-i18next';

import { createTask } from 'actions/tasks';

import { trackEvent } from 'services/events-tracker-service';

import { TasksDNDContext } from 'context/TasksDNDContext';

import TaskGroupTasksWithoutMilestone from 'components/TaskGroupTasksWithoutMilestone';

import IconArrowDown from 'icons/icon-arrow-down';
import IconArrowRight from 'icons/icon-arrow-right';

const TasksWithoutMilestone = ({ projectId, taskGroups, collapsed, onTaskClick, onExpand, onCollapse, t }) => {
    const tasksDNDContext = useContext(TasksDNDContext);

    const handleTaskCreate = useCallback((taskGroupId, name) => {
        createTask({
            project: projectId,
            task_group: taskGroupId,
            name
        }).then(() => {
            trackEvent('TASK.CREATE', {
                via: 'Milestone Overview'
            });
        });
    }, [projectId])

    const handleToggleClick = useCallback(() => {
        if (collapsed) {
            onExpand('completed');
        } else {
            onCollapse('completed');
        }
    }, [collapsed, onExpand, onCollapse]);

    return (
        <div className="milestone-overview">
            <div className="overview-main">
                <div className="overview-main-inner">
                    <div className={'overview-main-head' + (collapsed ? ' collapsed' : '')}>
                        <div className="overview-main-head-inner">
                            <span className="overview-main-head-text">
                                { t('Without Milestone') }
                            </span>
                        </div>

                        <span className="overview-main-head-icon overview-main-head-arrow" onClick={handleToggleClick}>
                            {
                                collapsed ? <IconArrowRight /> : <IconArrowDown />
                            }
                        </span>
                    </div>

                    {
                        !collapsed ? (
                            <div className="overview-main-body" />
                        ) : null
                    }
                </div>
            </div>

            {
                !collapsed ? (
                    <div className="overview-task-groups">
                        {
                            taskGroups.map(taskGroup => (
                                <div className="overview-group" key={taskGroup.id}>
                                    <div className="overview-group-list task-group">
                                        <TaskGroupTasksWithoutMilestone
                                            taskGroupId={taskGroup.id}
                                            maxVisibleTasks={3}
                                            simpleTask={true}
                                            labelsFetched={true}
                                            draggedTaskId={tasksDNDContext.draggedId}
                                            onCreateTask={handleTaskCreate}
                                            onTaskClick={onTaskClick}
                                            onTaskDragStart={tasksDNDContext.onDragStart}
                                            onTaskDragEnd={tasksDNDContext.onDragEnd}
                                            onTaskMove={tasksDNDContext.onMove}
                                        />
                                    </div>
                                </div>
                            ))
                        }

                        <div className="overview-group" key="completed">
                            <div className="overview-group-list task-group">
                                <TaskGroupTasksWithoutMilestone
                                    taskGroupId="completed"
                                    projectId={projectId}
                                    maxVisibleTasks={3}
                                    simpleTask={true}
                                    labelsFetched={true}
                                    draggedTaskId={tasksDNDContext.draggedId}
                                    onTaskClick={onTaskClick}
                                    onTaskDragStart={tasksDNDContext.onDragStart}
                                    onTaskDragEnd={tasksDNDContext.onDragEnd}
                                    onTaskMove={tasksDNDContext.onMove}
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
}

export default withTranslation('milestone')(TasksWithoutMilestone);
